/**
 * Semantic linter rule for MultiplayerSpawner, from Godot's configuration warning on
 * `spawn_path.is_empty() || !has_node(spawn_path)` (multiplayer_spawner.cpp:88-95). An absent key
 * is Godot's default `NodePath("")` (multiplayer_spawner.cpp:58), so only a present, non-empty path
 * that names no node in this file warns. A warning, not an error: the scene loads (ADR-0032).
 */
import { ruleRegistry } from '../../../linter/RuleRegistry.js';
import { extractNodePath } from '../../../linter/linterUtils.js';
import { resolveNodePath } from '../../../linter/nodePathResolve.js';
import { armDiagnostic, armEmits, groundedArm } from '../../../linter/ruleArms.js';
const arms = {
    spawnPathDangling: groundedArm('multiplayerspawner-spawn-path-dangling', { kind: 'configuration-warning' }),
};
function checkMultiplayerSpawner(context) {
    const { node, scene } = context;
    const raw = node.rawProperties.spawn_path;
    if (!raw)
        return [];
    const path = extractNodePath(raw);
    if (!path)
        return [];
    const target = resolveNodePath(scene, node, path);
    if (target.status !== 'missing')
        return [];
    return [
        armDiagnostic(arms.spawnPathDangling, node, `MultiplayerSpawner '${node.name}' has spawn_path set to NodePath("${path}"), which names no node in this file. A valid Spawn Path is required for MultiplayerSpawner to spawn nodes.`),
    ];
}
const multiplayerSpawnerSpawnPathRule = {
    meta: {
        name: 'valid-multiplayerspawner-spawn-path',
        description: "Warns when MultiplayerSpawner's spawn_path names no node in this file, mirroring Godot's own configuration warning",
        category: 'validation',
        applicableNodeTypes: ['MultiplayerSpawner'],
        emits: armEmits(arms),
    },
    check: checkMultiplayerSpawner,
};
ruleRegistry.register(multiplayerSpawnerSpawnPathRule);
//# sourceMappingURL=linter.js.map